export default [
  {
    path: "/rules-for-using-the-portal",
    name: "policy",
    meta: { title: 'policy' },
    component: () => import('@/pages/policy'),
  },
]
